import NewTable from "components/NewTable";
import useTransferenciaListagemColumns from "ui/components/TransferenciaTable/hooks/useTransferenciaListagemColumns";
import { TransferenciaItem } from "core/features/transferencia/typings";
import { NewTableProps } from "ui/components/NewTable";
import { MdDelete } from "react-icons/md";
import useExcluirTransferencia from "core/features/transferencia/hooks/useExcluirTransferencia";
import { showConfirm } from "infra/helpers/alerta";
import { PaginateResult } from "core/resources/types/shared";

interface TransferenciaTableProps {
  isLoading?: boolean;
  defaultSelectedRows?: TransferenciaItem[];
  transferencias?: PaginateResult<TransferenciaItem>;
  showHeader?: boolean;
  tableProps?: Partial<NewTableProps<TransferenciaItem>>;
  refetch?: () => any;
  onChangePage: (page: number, limit: number) => any;
}

function TransferenciaTable({
  isLoading,
  defaultSelectedRows = [],
  transferencias,
  showHeader,
  tableProps,
  refetch,
  onChangePage,
}: TransferenciaTableProps) {
  const columns = useTransferenciaListagemColumns();
  const { mutate: excluirTransferencia, isLoading: isLoadingExcluir } =
    useExcluirTransferencia();

  return (
    <NewTable<TransferenciaItem>
      key={isLoading || isLoadingExcluir ? "loading" : "default"}
      defaultSelectedRows={defaultSelectedRows}
      loading={isLoading || isLoadingExcluir}
      columns={columns}
      dataSource={transferencias?.items ?? []}
      showHeader={showHeader}
      customPagination={{
        onChangePage,
        currentPage: transferencias?.meta.currentPage,
        itemsPerPage: transferencias?.meta.itemsPerPage,
        totalItems: transferencias?.meta.totalItems,
      }}
      actions={[
        {
          title: "Excluir",
          icon: () => <MdDelete />,
          onClick: (v) =>
            showConfirm("Deseja realmente excluir essa transferência?").then(
              ({ isConfirmed }) => {
                if (isConfirmed) {
                  excluirTransferencia(v.id, {
                    onSuccess: () => refetch?.(),
                  });
                }
              }
            ),
        },
      ]}
      {...tableProps}
    />
  );
}

export default TransferenciaTable;
